/*
  Opens the product reviews tab before scrolling to the lightweight reviews section.
*/

(function () {
  function findReviewsPanel(target) {
    return (
      (target && target.closest('[role="tabpanel"]')) ||
      document.getElementById('panel-5') ||
      document.querySelector('[role="tabpanel"][aria-labelledby="tab-5"]')
    );
  }

  function activateReviewsTab(target) {
    const panel = findReviewsPanel(target);
    const tabId = panel && panel.getAttribute('aria-labelledby');
    const tab = document.getElementById(tabId || 'tab-5');
    const tabbedContent = (panel && panel.closest('tabbed-content')) || (tab && tab.closest('tabbed-content'));

    if (!panel || !tab) return;

    if (tabbedContent) {
      tabbedContent.querySelectorAll('[role="tab"]').forEach(function (button) {
        button.setAttribute('aria-selected', button === tab ? 'true' : 'false');
      });

      tabbedContent.querySelectorAll('[role="tabpanel"]').forEach(function (tabPanel) {
        tabPanel.hidden = tabPanel !== panel;
      });
    } else {
      tab.setAttribute('aria-selected', 'true');
      panel.hidden = false;
    }

    tab.click();
  }

  function openParentDetails(target) {
    let details = target && target.closest('details');

    while (details) {
      details.open = true;
      details = details.parentElement && details.parentElement.closest('details');
    }
  }

  function scrollToTarget(target) {
    if (!target) return;

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }

  document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-lite-product-rating-link]');
    if (!link) return;

    const targetId = link.getAttribute('href');
    if (!targetId || !targetId.startsWith('#')) return;

    const target = document.querySelector(targetId);
    if (!target) return;

    event.preventDefault();

    activateReviewsTab(target);
    openParentDetails(target);

    window.setTimeout(function () {
      scrollToTarget(target);
    }, 120);
  });
})();
